window.global ||= window;

import * as Sentry from '@sentry/react';
import { initializeCurrentLocation } from '@takeshape/redux-little-router';
import { assert } from '@takeshape/util';
import { createRoot } from 'react-dom/client';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/500-italic.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/700-italic.css';
import '@fontsource/roboto-mono/400.css';
import '@fontsource/roboto-mono/400-italic.css';
import '@fontsource/roboto-mono/700.css';
import '@fontsource/roboto-mono/700-italic.css';
import './common/utils/commons.css';
import './tailwind-daisyui.css';
import { getUser } from './auth/actions.js';
import { sentryDSN } from './config.js';
import Root from './containers/root.js';
import { reduxStore } from './store.js';

export type EditorAccessor = {
  getValue: () => string;
  setValue: (text: string) => void;
};

export type TakeShape = {
  playwright: boolean;
  apiExplorer?: {
    queryEditor: EditorAccessor;
    variablesEditor: EditorAccessor;
    headerEditor: EditorAccessor;
    responseEditor: EditorAccessor;
  };
  jsonSchemaEditor?: EditorAccessor;
  roleConditionsEditor?: EditorAccessor;
};

declare global {
  interface Window {
    takeshape: TakeShape;
  }
}

Sentry.init({
  dsn: sentryDSN,
  ignoreErrors: [
    // GraphiQL uncaught error on invalid enum in query variables
    /Value ".*" does not exist in ".*" enum./
  ]
});

// Initialize api-explorer store sync with Redux after store is created
void import('./api-explorer/store/store-sync.js');

// Refresh user permissions
if (reduxStore.getState().auth.user) {
  reduxStore.dispatch(getUser.requested());
}

const initialLocation = reduxStore.getState().router;
if (initialLocation) {
  // TODO correctly type
  reduxStore.dispatch(initializeCurrentLocation(initialLocation as any));
}

const container = document.getElementById('app');
assert(container, 'Root element #app not found');
const root = createRoot(container);
root.render(<Root store={reduxStore} />);
